import React from 'react';
import { CopyReferenceIcon } from './style';
import useFetchSurfaceNodesFromCache from 'components/canvas/hooks/use-fetch-surface-nodes-from-cache';
import useSaveNodeInCache from 'components/canvas/hooks/use-save-node-in-cache';
import useMutation from 'hooks/use-mutation';
import useTranslateWindowPointToCanvas from 'components/canvas/hooks/use-translate-window-point-to-canvas';
import { useNodeLinking } from 'state/canvas/node-linking';
import { useParams } from 'react-router';
import { useTranslation } from 'i18n';
import { copySurfaceNodeByReferenceMutation } from 'graphql/surface-node/mutations/copy-surface-node-by-reference';
import toast from 'services/toast';
import { SurfaceNodePointsTo } from 'graphql/types';
import useAddNodeToSurfaceInCache from 'components/canvas/hooks/use-add-node-to-surface-in-cache';

export interface CopyReferenceAndLinkButtonProps {
  globalLink: SurfaceNodePointsTo;
}

function CopyAndLinkButton({ globalLink }: CopyReferenceAndLinkButtonProps) {
  const { t } = useTranslation();
  const { id } = useParams();
  const surface = id as string;

  const fetchSurfaceNodesFromCache = useFetchSurfaceNodesFromCache(surface);

  const translatePointToCanvas = useTranslateWindowPointToCanvas(surface);

  const addNodeToCache = useAddNodeToSurfaceInCache();

  const windowCenter = {
    x: window.innerWidth / 2,
    y: window.innerHeight / 2,
  };

  const [copySurfaceNodeByReference] = useMutation(
    copySurfaceNodeByReferenceMutation,
  );

  const [_, { linkNodes, addConnection }] = useNodeLinking(surface);

  const [isDisabled, setDisabled] = React.useState<boolean>(false);

  React.useEffect(() => {
    const isDisabled = shouldActionBeDisabled();

    setDisabled(isDisabled);
  }, [globalLink]);

  function shouldActionBeDisabled(): boolean {
    // If toNode(global) has reference on current surface and it's linked to fromNode(local node)
    // return fetchSurfaceNodesFromCache()
    //   .filter((node) => node.isReference)
    //   .some((node) => {
    //     if (node?.originalNode?.id === globalLink.to.id) {
    //       return node.pointsTo.some(({ to }) => to.id === globalLink.from.id);
    //     }
    //     return false;
    //   });

    return false
  }

  function findReferenceOnSurface() {
    return fetchSurfaceNodesFromCache()
      .filter((node) => node.isReference)
      .find((node) => node?.originalNode?.id === globalLink.to.id);
  }

  function copyReferenceAndLink() {
    const position = translatePointToCanvas(windowCenter);

    const input = { id: globalLink.to.id, surface: surface, position };

    copySurfaceNodeByReference({ variables: { input } }).then((response) => {
      if (response.isSuccess) {
        const referenceNode = response.getField('data');
        addNodeToCache(referenceNode);

        return linkReferenceNodeToLocal(referenceNode);
      } else {
        toast.error(response.getErrorMessage());
      }
    });
  }

  function linkReferenceNodeToLocal(referenceNode) {
    const localLink = {
      ...globalLink,
      to: {
        id: referenceNode.id,
        surface: { id: surface },
      },
    } as any;

    addConnection({ ...localLink, to: referenceNode });

    toast.success(
      t('Successfully pinned node {{name}} to surface.', {
        replace: { name: referenceNode.name },
      }),
    );

    return linkNodes(localLink);
  }

  return <CopyReferenceIcon onClick={copyReferenceAndLink} />;
}

export default CopyAndLinkButton;
